export enum TypeOffreEnum {
  OffreNumerique = 'OFFRE_NUMERIQUE',
  OffreAutreCanal = 'OFFRE_AUTRE_CANAL'
}
